import { Box, FormControlLabel, Radio } from "@mui/material";
import { IWebTicket } from "app/WebEvent/interfaces";
import { FC } from "react";
import { useBasket, useBasketDispatch } from "../basketContext";
import { TicketUpsales } from "../TicketUpsales";
import { useSelector } from "react-redux";
import getSubtranslation from "helpers/getSubtranslation";
import BasketReducerActions from "../enums/BasketReducerActions";
import Availability from "./Availability";

type RadioTicketProps = {
    ticket: IWebTicket;
    isChecked: boolean;
};

const RadioTicket: FC<RadioTicketProps> = ({ ticket, isChecked }) => {
    const { guests } = useBasket();
    const dispatch = useBasketDispatch();

    const { "general-currency": currency } = useSelector(
        (state: any) => state.web.settings.location_settings,
    );

    const handleSelectTicket = () => {
        dispatch?.({
            type: BasketReducerActions.SET_SINGLE_TICKET,
            payload: ticket,
        });
    };

    return (
        <>
            <FormControlLabel
                value={ticket.id}
                control={
                    <Radio
                        size="small"
                        checked={isChecked}
                        disabled={
                            guests > ticket.current_available ||
                            ticket.current_available === 0
                        }
                        value={ticket.id}
                        disableRipple
                        onChange={handleSelectTicket}
                        sx={{
                            pt: "2px",
                        }}
                    />
                }
                sx={{
                    mr: 0,
                    color: "#495366",
                    alignItems: "flex-start",
                    ".MuiTypography-root": {
                        width: "100%",
                        fontSize: {
                            xs: 14,
                            tablet: 16,
                        },
                    },
                }}
                label={
                    <Box>
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "row",
                                // flexWrap: "wrap",
                                justifyContent: "space-between",
                                alignItems: "flex-start",
                                gap: 1.5,
                                rowGap: 1,
                                width: "100%",
                                // flex: 1,
                                fontFamily: "'Noto Sans', sans-serif",
                                fontSize: {
                                    xs: 14,
                                    tablet: 16,
                                },
                                fontWeight: 500,
                            }}
                        >
                            <Box
                                sx={{
                                    wordBreak: "break-word",
                                    color: {
                                        xs: "#495366",
                                        tablet: "#02263A",
                                    },
                                    flex: 1,
                                    // minWidth: "120px",
                                }}
                            >
                                {getSubtranslation(ticket.subtranslations.name)}
                            </Box>
                            <Box
                                sx={{
                                    display: "flex",
                                    // flex: 1,
                                    justifyContent: "end",
                                    color: {
                                        xs: "#495366",
                                        tablet: "#02263A",
                                    },
                                    ml: 1,
                                    whiteSpace: "nowrap",
                                }}
                            >
                                {ticket.base_price.price(currency, "left")}
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                minWidth: "132px",
                                mt: 1,
                            }}
                        >
                            <Availability ticket={ticket} quantity={guests} />
                        </Box>
                    </Box>
                }
            />
            {isChecked && <TicketUpsales ticket={ticket} />}
        </>
    );
};

export default RadioTicket;
